var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlinkcardBlue = function SvgBlinkcardBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2003_1",
    "data-name": "Component 2003 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 60,
    height: 60,
    rx: 5,
    fill: "#e5e5e5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1993_2",
    "data-name": "Component 1993 \\u2013 2",
    transform: "translate(11 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M36.2,4H5.8A3.809,3.809,0,0,0,2.019,7.875L2,31.125A3.825,3.825,0,0,0,5.8,35H36.2A3.825,3.825,0,0,0,40,31.125V7.875A3.825,3.825,0,0,0,36.2,4Zm0,27.125H5.8V19.5H36.2Zm0-19.375H5.8V7.875H36.2Z",
    transform: "translate(-2 -4)",
    fill: "#205171"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlinkcardBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blinkcard-blue.44fc5cf091ba471c403b06868dbc6d5d.svg";